import axios from 'axios';
import { APIBASEURL } from '../config/settings';
import authHeader from '../services/auth-header';

const SIGN_URL = `${APIBASEURL}/upload/sign`;

// Uploads `file` to S3 via a backend-issued presigned PUT URL.
// `dirName` must be one of the allowlisted directories on the API
// (teams, players, users, leagues, highlights, games, sponsors, uploads).
// Returns { publicUrl, path } — `path` is what callers historically stored
// (everything after the bucket host, prefixed with /).
export async function uploadToS3({ file, dirName }) {
    if (!file) throw new Error('file is required');
    if (!dirName) throw new Error('dirName is required');

    const { data } = await axios.post(
        SIGN_URL,
        {
            dirName,
            contentType: file.type || 'application/octet-stream',
            fileName: file.name,
        },
        { headers: authHeader() }
    );

    await axios.put(data.uploadUrl, file, {
        headers: { 'Content-Type': file.type, 'x-amz-acl': 'public-read' },
        // Don't send our auth token to S3.
        transformRequest: [(d) => d],
    });

    return { publicUrl: data.publicUrl, path: data.path };
}
